
export default {
  data(){
    return {
      scrollable: false,
      start: true,
      end: false
    }
  },
  mounted(){
    this.handleScroll()
  },
  methods: {
    getContent(){
      return this.$refs.scroller.getContent()
    },
    handleScroll(){
      const el = this.getContent()
      this.scrollable = el.scrollWidth > el.clientWidth
      this.start = this.scrollable && Math.abs(el.scrollLeft) === 0
      this.end = this.scrollable && Math.abs(el.scrollLeft) >= el.scrollWidth - el.clientWidth - 1
    },
    getTable(){
      return this.getContent().querySelector('table')
    }
  }
}
